import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import type { FC, ReactNode, Ref, RefObject } from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import type { Moment } from 'moment';
import { IconButton } from '@mui/material';
import CalendarIcon from '../../../../assets/calendarIcon.svg';
import { useState } from 'react';
import React from 'react';

interface DatePickerProps {
  id: string;
  disabled?: boolean;
  disableFuture?: boolean;
  disablePast?: boolean;
  displayWeekNumber?: boolean;
  format?: string;
  inputRef?: Ref<HTMLElement>;
  label?: ReactNode;
  maxDate?: Moment;
  minDate?: Moment;
  open?: boolean;
  views?: Array<'day' | 'month' | 'year'>;
  value?: Moment;
  defaultValue?: Moment;
  className?: string;
  variant?: 'outlined' | 'filled' | 'standard';
  shouldDisableDate?: (day: Moment) => boolean;
  onError?: (error: string | null) => void;
  slotProps?: object;
  onChange?: (date: Moment | null) => void;
}

const CustomDatePicker: FC<DatePickerProps> = ({
  id,
  disabled = false,
  disableFuture = false,
  disablePast = false,
  displayWeekNumber,
  format,
  inputRef,
  label,
  maxDate,
  minDate,
  open,
  views,
  value,
  defaultValue,
  className,
  shouldDisableDate,
  onError,
  variant = 'outlined',
  slotProps,
  onChange,
}) => {
  const [openState, setOpenState] = useState(false);

  const handleIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpenState(true);
  };
  const handleError = (error: string | null) => {
    if (onError) {
      onError(error); // Call the onError function with no arguments
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        disableFuture={disableFuture}
        className={className}
        disabled={disabled}
        disablePast={disablePast}
        displayWeekNumber={displayWeekNumber}
        format={format}
        inputRef={inputRef as RefObject<HTMLInputElement>}
        label={label}
        maxDate={maxDate}
        minDate={minDate}
        // open={open}
        views={views}
        value={value}
        defaultValue={defaultValue}
        shouldDisableDate={shouldDisableDate}
        onError={handleError}
        open={open ?? openState}
        onOpen={() => setOpenState(true)}
        onClose={() => setOpenState(false)}
        onChange={onChange}
        slotProps={{
          ...slotProps,
          textField: {
            id: id, // Unique ID for automation testing
            variant: variant,
            sx: {
              width: '100%',
              '& .MuiOutlinedInput-root': {
                height: '37px',
              },
            },
            InputProps: {
              endAdornment: (
                <IconButton size="small" onClick={handleIconClick}>
                  <CalendarIcon />
                </IconButton>
              ),
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
